import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/trending";

export default function PortalNavbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState("热榜");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200/80 shadow-sm"
          : "bg-background-50"
      }`}
    >
      <div className="mx-auto flex h-16 md:h-20 w-full items-center justify-between px-4 md:px-6">
        {/* logo */}
        <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
          <span className="font-display text-3xl md:text-4xl leading-none text-primary-500">
            91cg
          </span>
          <span className="hidden lg:flex flex-col leading-tight pl-3 border-l border-background-200">
            <span className="text-sm font-bold text-foreground-900">91cg热榜</span>
            <span className="text-xs text-foreground-500">热门吃瓜排行榜</span>
          </span>
        </a>

        {/* desktop nav */}
        <nav className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <a
              key={link}
              href="#top"
              onClick={() => setActive(link)}
              className={`px-3 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                active === link
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-700 hover:text-primary-600 hover:bg-primary-50"
              }`}
            >
              {link}
            </a>
          ))}
        </nav>

        {/* actions */}
        <div className="flex items-center gap-2 md:gap-3">
          <div className="hidden sm:flex items-center gap-2 rounded-full bg-background-100 border border-background-200 px-3 py-2">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-search-line text-sm text-foreground-400"></i>
            </span>
            <input
              type="text"
              placeholder="搜一搜今天在讨论什么"
              className="w-40 md:w-52 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
            />
          </div>
          <button className="whitespace-nowrap cursor-pointer text-sm font-medium bg-primary-500 text-background-50 rounded-full px-4 md:px-5 py-2 hover:bg-primary-600 transition-colors">
            发布围观
          </button>
          <button
            onClick={() => setOpen(!open)}
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg text-foreground-800 hover:bg-background-100 cursor-pointer"
            aria-label="菜单"
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-3-line text-xl"}></i>
          </button>
        </div>
      </div>

      {/* mobile menu */}
      {open && (
        <div className="md:hidden border-t border-background-200/70 bg-background-50 px-4 py-3">
          <div className="grid grid-cols-2 gap-2">
            {navLinks.map((link) => (
              <a
                key={link}
                href="#top"
                onClick={() => {
                  setActive(link);
                  setOpen(false);
                }}
                className={`px-3 py-2 rounded-lg text-sm text-center font-medium cursor-pointer ${
                  active === link
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                {link}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}